/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Business,
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateBusinessesImagesBody
 */
export interface UpdateBusinessesImagesBody {
    /**
     * 
     * @type {Array<Business>}
     * @memberof UpdateBusinessesImagesBody
     */
    businesses?: Array<Business>;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessesImagesBody
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessesImagesBody
     */
    headerImage?: string;
}

export function UpdateBusinessesImagesBodyFromJSON(json: any): UpdateBusinessesImagesBody {
    return UpdateBusinessesImagesBodyFromJSONTyped(json, false);
}

export function UpdateBusinessesImagesBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessesImagesBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'businesses': !exists(json, 'businesses') ? undefined : ((json['businesses'] as Array<any>).map(BusinessFromJSON)),
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'headerImage': !exists(json, 'headerImage') ? undefined : json['headerImage'],
    };
}

export function UpdateBusinessesImagesBodyToJSON(value?: UpdateBusinessesImagesBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'businesses': value.businesses === undefined ? undefined : ((value.businesses as Array<any>).map(BusinessToJSON)),
        'icon': value.icon,
        'headerImage': value.headerImage,
    };
}


